import { Component } from "react";
import {
    View,
    Image,
    Dimensions,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Commons from "../utils/Commons";
import * as Animatable from "react-native-animatable";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let isMobile = false;
let scale = 1;
const imgSplashLogo = require("../images/SplashScreen/SplashLogo.png");
const imgSplash = require("../images/MyOrders/splashJDS.png");
const imgJoDrugStore = require("../images/SplashScreen/JordanDrugStore.png");
class SplashScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fadeOut: false,
        };
    }
    Pressables = {};

    async componentDidMount() {
        setTimeout(() => {
            this.setState({ fadeOut: true });
            setTimeout(() => {
                // window.location = './ClientHomePage';
                this.props.navigation.navigate("ClientHomePage");
            }, 500);
        }, 2000);
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={[styles.container, { justifyContent: 'center', alignItems: 'center' }]} >
                <View style={{ width }}>
                    {/* {Commons.loadFonts(this)} */}
                    {/* {Styles.renderVSeparator(0)} */}
                    {this.renderPart1Mobile()}
                </View>
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        width = Commons.getWidth();
        styles = this.styles();
        marginTop = 300;
        styles = this.styles();
        return (
            <View style={styles.container}>
                    {Commons.loadFonts(this)}
                    {this.renderPart1()}
            </View >
        );
    }

    renderPart1 = () => {
        return (
            <Animatable.View style={{ alignItems: "center", justifyContent: "center", }}
                animation={this.state.fadeOut ? "fadeOut" : "fadeIn"}>
                <Image source={imgSplashLogo} style={{ width: 95.713, height: 101,top: (height - 100) / 2 }} />
                <Image source={imgSplash} style={{ width: 550, height: height - 100, position: "absolute", top: 50, tintColor: 'rgba(59, 98, 127, 0.05)' }} />
                <Image source={imgJoDrugStore} style={{ width: 80.476, height: 30.702, position: "absolute", top: height - 100 }} />
            </Animatable.View>
        )
    }

    renderPart1Mobile = () => {
        return (
            <Animatable.View style={{ alignItems: "center", justifyContent: "center", }}
                animation={this.state.fadeOut ? "fadeOut" : "fadeIn"}>
                <Image source={imgSplashLogo} style={{ width: 95.713, height: 101, }} />
                <Image source={imgSplash} style={{ width: width - 20, height, position: "absolute", top: -382.8355, tintColor: 'rgba(59, 98, 127, 0.05)' }} />
                <Image source={imgJoDrugStore} style={{ width: 80.476, height: 30.702, position: "absolute", top: height / 2 }} />
            </Animatable.View>
        )

    }

    renderPart2 = () => {

    }

    renderPart2Mobile = () => { 

    }

    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
        }
    });
}



export default SplashScreen;
